import { normalizePhoneId } from "./liveChatRealtime";

export function chatRoom(userId, phoneId, customerPhone) {
  return `chat:${userId}:${normalizePhoneId(phoneId)}:${customerPhone}`;
}

export function parseChatRoomId(roomId) {
  const parts = roomId?.split(":");
  if (!parts || parts.length !== 4 || parts[0] !== "chat") return null;
  return {
    userId: parts[1],
    phoneNumberId: parts[2],
    customerPhone: parts[3],
  };
}
